<form [formGroup]="formGroup">
  <app-form-field [type]="fields.name.type" [options]="fields.name.options"></app-form-field>
  <app-form-field [type]="fields.reels_limit.type" [options]="fields.reels_limit.options"></app-form-field>
  <app-form-field [type]="fields.units_limit.type" [options]="fields.units_limit.options"></app-form-field>
  <app-form-field [type]="fields.media_limit.type" [options]="fields.media_limit.options"></app-form-field>
  <app-form-field [type]="fields.groups_limit.type" [options]="fields.groups_limit.options"></app-form-field>
  <app-form-field [type]="fields.nombre_comercial.type" [options]="fields.nombre_comercial.options"></app-form-field>
  <app-form-field [type]="fields.razon_social.type" [options]="fields.razon_social.options"></app-form-field>
  <app-form-field [type]="fields.active.type" [options]="fields.active.options"></app-form-field>
</form>
<div class="modal-footer">
  <button class="btn btn-success" (click)="submit()" [disabled]="!formGroup.valid"><i class="fa fa-save"></i> Guardar</button>
  <button class="btn btn-danger" (click)="modalRef.hide()"><i class="fa fa-times"></i> Cancelar</button>
</div>
